<template>


    <AppLayout :title="__('Mails')">

        <div class="h-full">

            <div class="max-w-9xl mx-auto sm:px-6 lg:px-8 h-full">

                <div class="grid grid-cols-2"
                     style="grid-template-rows:  max-content minmax(200px, max-content);">

                    <div class="flex">

                        <h1 class="my-4 text-2xl font-nexa text-dark-blue h-[30px]">

                            Campaign Mails: {{ campaign.name }}

                        </h1>


                        <a class="p-2 my-3 ml-4 bg-dark-blue items-center flex cursor-pointer w-max"
                           @click.prevent="$inertia.visit( route('campaign_rule', {
                               campaign_rule: campaign_rule.id
                           }) );">


                            <font-awesome-icon
                                class="mr-1 ml-2 text-white cursor-pointer"
                                style="width: 16px; height: 16px;"
                                size="sm"
                                :icon="['fas', 'arrow-left']" />


                            <h1 class="text-sm ml-1 font-nexa text-white cursor-pointer"
                                style="line-height: 1.5rem">

                                {{ __('Back to Campaign') }}

                            </h1>


                        </a>


                    </div>


                    <NordenTable
                        :headers="mails_headers"
                        :rows="content"
                        @flag_clicked="handle_flag_clicked">
                    </NordenTable>


                </div>

            </div>

        </div>

    </AppLayout>

</template>

<script>
import { defineComponent } from 'vue'
import AppLayout from "../Layouts/AppLayout";
import NordenTable from '../Components/NordenTable';

export default defineComponent({

    name: "Mails",

    components: {
        NordenTable,
        AppLayout
    },

    props: {
        campaign_rule: Object,
        campaign: Object,
        content: Array
    },

    data() {
        return {
            mails_headers: [
                {
                    name: 'ID',
                    text_key: 'id',
                    value_key: 'id',
                    column_width: '50px',
                    class: '',
                },
                {
                    name: 'Subscriber',
                    text_key: 'subscriber_name',
                    value_key: 'subscriber_name',
                    column_width: 4,
                    class: 'truncate',
                },
                {
                    name: 'Sent',
                    text_key: 'sent',
                    value_key: 'sent',
                    column_width: '150px',
                    class: '',
                },
                {
                    name: 'Languages',
                    text_key: 'languages',
                    type: 'component',
                    component: 'flag-links',
                    value_key: 'languages',
                    column_width: '220px',
                    class: 'inline-flex whitespace-no-wrap',
                }
            ]
        };
    },

    methods: {

        handle_flag_clicked(link) {

            window.open(link, '_blank');

        }

    }

});
</script>

<style scoped>

</style>
